import { maybe } from './util'

export function isFbEnabled(flag: string): boolean {
  return maybe(() => window.visually.flags[flag] as boolean, false)!
}

export function isDeferWidgetsEnabled(): boolean {
  return maybe(() => window.vslyDeferWidgets === true || isFbEnabled("sdk-defer-widgets"), false)!
}
